export function changeSelectedGifts(giftGroup, gift) {
  const availableGifts = giftGroup.availableGifts
  let selectedGifts = availableGifts.filter((item) => {
    return item.isSelected
  })

  const indexOfGift = selectedGifts.findIndex((item) => {
    return item.id === gift.id
  })
  if (indexOfGift >= 0) {
    selectedGifts.splice(indexOfGift, 1)
  } else {
    if (giftGroup.availableQuantity === selectedGifts.length) {
      selectedGifts = []
    }
    selectedGifts.push(gift)
  }

  const reducedSelectedGifts = selectedGifts.map((selectedGift) => {
    return {
      id: selectedGift.id,
      seller: selectedGift.seller,
    }
  })

  return reducedSelectedGifts
}
